import { Col, notification, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import SubHeader from '../../../components/SubHeader';
import { useAuth } from '../../../security/authContext';
import apiAuth from '../../../services/apiAuth';
import apiShipper from '../../../services/apiShipper';
import { getColumns } from './columns';
import ModalCnpjsSecundarios from './Modal/modalCnpjsSecundarios';
import { Content, IncluirButton, Table } from './styles';

/**
 * Página para a listagem de usuários
 */
export default function ListagemUsuarios() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [arrayCnpjsSecundarios, setArrayCnpjsSecundarios] = useState({});
  const [loadingTable, setLoadingTable] = useState(false);
  const history = useHistory();
  const [showModalCnpjsSecundario, setShowModalCnpjsSecundario] = useState(
    false
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    position: ['bottomCenter'],
  });
  const [filtersPage, setFiltersPage] = useState({});

  const definirOrdenacao = (params, sorter) => {
    const order = sorter.order === 'ascend' ? 'ASC' : 'DESC';

    params.orderBy = order;
    params.sortBy = sorter.columnKey;

    return params;
  };

  const handleShowModalCnpjsSecundario = async cnpjsSecundarios => {
    setShowModalCnpjsSecundario(true);

    if (!cnpjsSecundarios) return;

    try {
      const { data } = await apiShipper.get('/clientes', {
        params: {
          idClienteSecundarios: cnpjsSecundarios,
          size: cnpjsSecundarios.split(',').length,
        },
      });

      setArrayCnpjsSecundarios(data.content);
    } catch (err) {
      notification.error({
        message: 'Não foi possível carregar os dados',
        description:
          'Caso o problema persista, entre em contato com nosso suporte.',
      });
    }
  };

  const cleanCnpjsSecundario = () => {
    setArrayCnpjsSecundarios({});
  };

  const handleCloseModalCnpjsSecundario = () => {
    setShowModalCnpjsSecundario(false);
    cleanCnpjsSecundario();
  };

  const definirFiltrosDinamicos = (params, filters) => {
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        const [value] = filters[key];

        const possibleKeys = [
          'name',
          'cpf',
          'email',
          'razao_social',
          'cnpj_resumido',
        ];
        if (possibleKeys.includes(key)) {
          params[key] =
            params[key] === 'cpf'
              ? String(value).replace(/\D/g, '')
              : String(value);
        }
      }
    });
    return params;
  };

  const handlerOnChangePagination = async () => {
    try {
      setLoadingTable(true);
      let options = {
        page: pagination.current,
        size: pagination.pageSize,
        user_cliente_id: user?.cliente_id,
        user_perfil: user?.profile,
        user_cliente_secundarios_id: user?.cliente_id_secundarios,
      };

      if (filtersPage?.sorter?.order) {
        options = {
          ...definirOrdenacao(options, filtersPage.sorter),
        };
      }

      if (filtersPage?.filters && Object.keys(filtersPage.filters).length) {
        options = {
          ...definirFiltrosDinamicos(options, filtersPage.filters),
        };
      }

      const response = await apiAuth.get('/users/shipper', {
        params: { ...options },
      });

      setUsers(response.data.data);

      const {
        page: current,
        size: pageSize,
        total_elements: total,
      } = response.data;

      setPagination({
        ...pagination,
        current,
        pageSize,
        total,
      });
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os usuários',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingTable(false);
    }
  };

  // função que incia na construção do componente
  useEffect(() => {
    /**
     * Recupera todos os usuários da api-auth
     */
    async function getAllUsers() {
      handlerOnChangePagination();
    }

    getAllUsers();
  }, [filtersPage]);

  /**
   * Redireciona o usuário para tela de criação de um novo usuário.
   */
  const handleNewUser = () => {
    history.push('/usuarios/novo');
  };

  /**
   * Redireciona o usuário para tela de edição de um usuário.
   * @param {Number} idUsuario ID do usuário
   */
  const handleEditUser = ({ idUsuario }) => {
    history.push(`usuarios/${idUsuario}`);
  };

  const onChangeTable = (paginationParam, filters, sorter) => {
    setPagination({
      ...paginationParam,
    });
    setFiltersPage({
      ...filtersPage,
      filters,
      sorter,
    });
  };

  const columnsTable = getColumns(
    handleEditUser,
    filtersPage,
    handleShowModalCnpjsSecundario,
    handleCloseModalCnpjsSecundario
  );

  return (
    <>
      <ModalCnpjsSecundarios
        arrayCnpjsSecundarios={arrayCnpjsSecundarios}
        showModalCnpjsSecundario={showModalCnpjsSecundario}
        handleShowModalCnpjsSecundario={handleShowModalCnpjsSecundario}
        handleCloseModalCnpjsSecundario={handleCloseModalCnpjsSecundario}
      />
      <SubHeader title="CADASTRO DE USUÁRIOS" />
      <Content>
        <Col span={24}>
          <Row gutter={[8, 16]} justify="end">
            <Col>
              <IncluirButton type="primary" onClick={handleNewUser}>
                Incluir novo usuário
              </IncluirButton>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                loading={loadingTable}
                bordered={true}
                dataSource={
                  users.length &&
                  users.map(user => ({
                    ...user,
                    key: user.idUsuario,
                  }))
                }
                onChange={onChangeTable}
                columns={columnsTable}
                pagination={{
                  ...pagination,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Content>
    </>
  );
}
